import { render, staticRenderFns } from "./Type.vue?vue&type=template&id=a47ec482&scoped=true"
import script from "./Type.vue?vue&type=script&lang=js"
export * from "./Type.vue?vue&type=script&lang=js"
import style0 from "./Type.vue?vue&type=style&index=0&id=a47ec482&prod&lang=scss&scoped=true"
import style1 from "./Type.vue?vue&type=style&index=1&id=a47ec482&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47ec482",
  null
  
)

export default component.exports